









































































import Vue from 'vue'
import { mapState } from 'vuex';
export default Vue.extend({
  props: {
    redirect: String
  },
  data() {
    return {
      methods: [] as string[],
      email: {
        class: "",
        help: "",
        value: ""
      },
      password: {
        class: "",
        help: "",
        value: ""
      }
    }
  },
  computed: {
    ...mapState([
      "auth"
    ])
  },
  methods: {
    getSignInMethods() {
      this.$auth.fetchSignInMethodsForEmail(this.email.value).then(methods => {
        this.methods = methods
        this.$store.dispatch('auth/setMethods', methods)
        if (methods.indexOf('password') > -1) {
          const focusPassword = setInterval(() => {
            const passwordInput = document.getElementById('password-input')
            if (passwordInput) {
              passwordInput.focus()
              clearInterval(focusPassword)
            }
          }, 50)
        }
      }).catch(error => {
        alert(error.message)
      })
    },
    signIn(method:string) {

      const provider = (key:string) => {
        if (key == 'google.com') {
          //@ts-ignore
          return new this.$firebase.auth.GoogleAuthProvider()
        } else if (key == 'microsoft.com') {
          //@ts-ignore
          return new this.$firebase.auth.OAuthProvider('microsoft.com')
        }
      }
      
      switch(method) {
        case 'password':
          this.$auth.signInWithEmailAndPassword(this.email.value, this.password.value)
          .catch(error => {
            alert(error)
          })
          break
        default:
          this.$auth.signInWithPopup(provider(method))
          .catch(error => {
            alert(error.message)
          })
      }
    }
  },

  created() {
    this.$auth.onAuthStateChanged(user => {
      if (user) {
        this.$router.push(this.redirect ? this.redirect : "/")
      }
    })
  }
})
